module.exports = __webpack_public_path__ + "img/tenant_console_home@1x.6d791e54.png";